import { Permission } from '@models/auth.model';
import { AirportsGroup } from '@models/dropdown-list.model';
import { StoreModel } from '@models/store.model';
import { createSelector } from '@ngrx/store';

// Metadata
export const selectCabinDDL = (state: StoreModel) => state.common.metadata.cabinDDL;
export const selectPartnerDDL = (state: StoreModel) => state.common.metadata.partnerDDL;
export const selectAirPortDDL = (state: StoreModel) => state.common.metadata.airPortDDL;
export const selectAirlineDDL = (state: StoreModel) => state.common.metadata.airlineDDL;
export const selectCountriesDDL = (state: StoreModel) => state.common.metadata.countriesDDL;
export const selectAirCraft = (state: StoreModel) => state.common.metadata.airCrafts;
export const selectPermissions = (state: StoreModel) => state.common.auth.permissions;
export const selectSession = (state: StoreModel) => state.common.auth.session;

export const mapAirPortObjectDLL = (state: StoreModel) => {
    return state.common.metadata.airPortDDL.reduce(
        (acc: Record<string, AirportsGroup>, curr: AirportsGroup) => {
            acc[curr.AirPortCode] = curr;
            return acc;
        },
        {} as Record<string, AirportsGroup>
    );
}

export const selectAirPortObject = createSelector(mapAirPortObjectDLL, (state) => state);

const mapPermissionsObjectDLL = (state: StoreModel) => {
    return state.common.auth.permissions.reduce(
        (acc: Record<string, Permission>, curr: Permission) => {
            acc[`${curr.ControllerName}-${curr.ActionName}`] = curr;
            return acc;
        },
        {} as Record<string, Permission>
    );
}

export const selectPermissionsObject = createSelector(mapPermissionsObjectDLL, (state) => state);
